module.exports = __webpack_public_path__ + "img/visiteFontainebleau.2e8c4bae.jpg";